import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import Tasks from './index';
import TaskStatus from './TaskStatus';
import { getTasksByAsset, updateTasks, getTaskByTaskId } from '../../api';
import Spinner, {spinnerOff, spinnerOn} from "../../components/Spinner";
import {confirmAlert} from "react-confirm-alert";
import InvalidDataConfirm from "../../components/ConfirmPopUp";

class TaskContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            assetName: '',
            preFormSignedFl: 'N',
            assetDeleteFl: 'N',
            tasks: [],
            projectStatus: props.project.projectStatus,
            bpid:'',
        }
    }

     async componentDidMount() {
        spinnerOn();
        this.getTasks();
         spinnerOff();
    }

    render() {
        const {params} = this.props.match;
        const {section, ipsLocation} = this.props;
        const { tasks, assetName, preFormSignedFl, projectStatus, assetDeleteFl, bpid } = this.state;
        
      
        return (
            <Tasks
                assetDetail={tasks}
                assetName={assetName}
                preFormSignedFl={preFormSignedFl}
                assetDeleteFl={assetDeleteFl}
                assetId={params.assetId}
                section={section}
                ipsLocation={ipsLocation}
                tasks={[
                    this.buildTasks('Pre-Energization', tasks.preEnergization || []),
                    this.buildTasks('In-Service', tasks.inService || []),
                    this.buildTasks('Documentation', tasks.documentation || [])
                ]}
                onSignEvent={(task) => this.updateTaskStatus(TaskStatus.SIGNED, task)}
                onRequestSignEvent={(task) => this.updateTaskStatus(TaskStatus.REQUESTED, task)}
                onMarkNaEvent={(task) => this.updateTaskStatus(TaskStatus.NA, task)}
                onMarkTempEvent={(task) => this.updateTaskStatus(TaskStatus.TEMPORARY, task)}
                onUndoEvent={(task) => this.updateTaskUndo(TaskStatus.UNDO, task)}
                projectStatus={projectStatus}
                bpid={bpid}
                projectData={this.props.project}
            />
        )
    }

    buildTasks(name, tasks) {
        return {
            name,
            tasks,
        }
    }

    async getTasks() {
        const {params} = this.props.match;
        try {

            const tasks = await getTasksByAsset(params.assetId);
            this.setState({
                tasks,
                assetName: tasks.assetName,
                preFormSignedFl: tasks.preFormSignedFl,
                assetDeleteFl: tasks.assetDeleteFl,
                pbid: tasks.bpid,
                

            })
        } catch (err) {
            console.log(err);
        }
    }

    async getTaskById(assetId, taksId) {
        try {
           const data =  await getTaskByTaskId(assetId, taksId);
           return data;
        } catch (err) {
            console.log(err);
            return null;
        }
    }

    async updateTaskStatus(statusId, tasks) {
          try {
          const updatedTasks = tasks.map(task => ({...task, ...{statusId}}));
           const statusUpdated = await updateTasks(updatedTasks);

           if(statusUpdated.updated === true){
                InvalidDataConfirm();
           }
            this.getTasks();
        } catch (err) {
            console.log(err) 
        }
    }

    async updateTaskUndo(statusId, tasks) {
        try {
        const updatedTasks = tasks.map(task => ({...task, ...{statusId}}));
        const statusUpdated = await updateTasks(updatedTasks);
        
        if(statusUpdated.updated === true){
            InvalidDataConfirm();
        }
        const updatedSingleTask = await this.getTaskById(updatedTasks[0].assetId, updatedTasks[0].taskId);
        if (!updatedSingleTask || typeof updatedSingleTask !== 'object') {
            console.warn("Fetched task is not a valid object:", updatedSingleTask);
            this.setState({ isLoading: false, error: "Fetched updated task is invalid." });
            return;
        }
        
        this.setState(prevState => {
        if (!prevState.tasks || typeof prevState.tasks !== 'object') {
            console.error("setState: CRITICAL ERROR: prevState.tasks is not an object or is null at initial check:", prevState.tasks);
            return {
                tasks: { preEnergization: [], documentation: [], inService: [] },
                isLoading: false,
                error: "Internal error: Tasks state structure corrupted at start of update."
            };
        }
        
        const newTasksData = { ...prevState.tasks };
    
        const listNames = ['preEnergization', 'documentation', 'inService'];
        let taskFoundAndUpdated = false;
        
        for (const listName of listNames) {
        
            // Get a reference to the current list item from newTasksData
            const currentListInLoop = newTasksData[listName];
        
        
            if (Array.isArray(currentListInLoop)) {
                const updatedList = currentListInLoop.map(task => {
                    if (task === null || task === undefined) {
                        return task;
                    }
            
                    if (task.assetId === updatedSingleTask.assetId && task.taskId === updatedSingleTask.taskId) {
                        taskFoundAndUpdated = true;
                        return updatedSingleTask; 
                    }
                    return task; 
                });
            
                if (taskFoundAndUpdated) {
                    newTasksData[listName] = updatedList;
                    break; 
                }
            } else {
                console.warn(`setState: "${listName}" is NOT an array. Type: "${typeof currentListInLoop}", Value:`, currentListInLoop);
            }
        }
                
        return {
            tasks: newTasksData,
            assetName: updatedSingleTask.assetName || prevState.assetName,
            preFormSignedFl: updatedSingleTask.preFormSignedFl || prevState.preFormSignedFl,
            assetDeleteFl: updatedSingleTask.assetDeleteFl || prevState.assetDeleteFl,
            pbid: updatedSingleTask.bpid || prevState.pbid, 
            isLoading: false, 
        } ;
        });
        } catch (err) {
            console.log(err) 
        }
    }

}
   export default withRouter(TaskContainer);